import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class, _class2, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { connect } from 'react-redux';
import moment from 'moment';
import * as _ from 'lodash';
import { getPartnerDetailsByPartnerOrgId } from 'redux/modules/teamManagement';
import { getPartnerBillingHistory, getPartnerDefaultPaymentMethod, showStripeError, updatePartnerDefaultPaymentMethod } from 'redux/modules/billing';
import { QueueFlyoutTab, DataTable, PageHeader, BillingForm } from 'components';
import { AppLayout, LeftNavLayout } from 'containers';
import * as styles from './BillingManagement.scss';
import Dialog from 'material-ui/Dialog';
var BillingManagement = (_dec = connect(function (state) {
  return {
    clientDetail: state.teamManagement.clientDetail,
    theme: state.theme,
    config: state.config,
    partnerDetails: state.teamManagement.partnerDetails,
    subscriptionBillingHistory: state.billing.subscriptionBillingHistory,
    loadingPartnerBillingHistory: state.billing.loadingPartnerBillingHistory,
    partnerBillingDetails: state.billing.partnerBillingDetails,
    form: state.form
  };
}, {
  getPartnerDetailsByPartnerOrgId: getPartnerDetailsByPartnerOrgId,
  getPartnerBillingHistory: getPartnerBillingHistory,
  getPartnerDefaultPaymentMethod: getPartnerDefaultPaymentMethod,
  updatePartnerDefaultPaymentMethod: updatePartnerDefaultPaymentMethod
}), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(BillingManagement, _Component);

  var _super = _createSuper(BillingManagement);

  function BillingManagement(props) {
    var _this2;

    _classCallCheck(this, BillingManagement);

    _this2 = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this2), "renderDetails", function (fields, details) {
      return fields.map(function (f, index) {
        return /*#__PURE__*/React.createElement("h6", {
          key: index,
          className: styles.detail
        }, /*#__PURE__*/React.createElement("span", {
          className: styles.detailName
        }, f.name, ":"), " ", details[f.key]);
      });
    });

    _defineProperty(_assertThisInitialized(_this2), "handleBillingFormSubmit", function (formData) {
      _this2.setState({
        checkoutInProgress: true
      });

      var _this = _assertThisInitialized(_this2);

      Stripe.card.createToken({
        number: _this2.props.form.billing.values.cardNumber,
        exp_month: _this2.props.form.billing.values.expMonth,
        exp_year: _this2.props.form.billing.values.expYear,
        cvc: _this2.props.form.billing.values.cvc,
        name: _this2.props.form.billing.values.name,
        address_zip: _this2.props.form.billing.values.postcode
      }, function (status, response) {
        _this.setState({
          checkoutInProgress: false
        });

        if (response.error) {
          return _this2.props.showStripeError(response.error);
        }

        if (status === 200) {
          formData.sourceToken = response.id;

          _this2.setState({
            editPaymentMethodModal: false
          });

          _this2.props.updatePartnerDefaultPaymentMethod(formData).then(function () {
            return _this2.props.getPartnerDefaultPaymentMethod();
          })["catch"](function (err) {
            return console.error(err);
          });
        } else {
          console.log(status, response);
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this2), "componentDidMount", function () {
      Stripe.setPublishableKey(_this2.props.config.stripePublicKey);
    });

    _this2.state = {
      editPaymentMethodModal: false,
      checkoutInProgress: false
    };
    return _this2;
  }

  _createClass(BillingManagement, [{
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      this.props.getPartnerBillingHistory(this.props.theme.org);
      this.props.getPartnerDetailsByPartnerOrgId(this.props.theme.org);
      this.props.getPartnerDefaultPaymentMethod();
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var partnerBillingDetails = this.props.partnerBillingDetails;
      var contractInfo = this.props.partnerDetails;
      var sidebarItems = [{
        link: '/user/billing',
        linkText: 'Billing'
      }].concat(_toConsumableArray(contractInfo && contractInfo.mlp === true ? [] : [{
        link: '/user/commissions',
        linkText: 'Commissions'
      }]));
      return /*#__PURE__*/React.createElement("div", {
        className: "container-fluid",
        style: {
          marginLeft: 183
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "row",
        style: {
          padding: 36,
          paddingBottom: 0
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12"
      }, /*#__PURE__*/React.createElement(PageHeader, {
        primary: "Billing Management"
      }))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Dialog, {
        open: this.state.editPaymentMethodModal,
        title: "Change Payment Method",
        onRequestClose: function onRequestClose() {
          return _this3.setState({
            editPaymentMethodModal: false
          });
        }
      }, /*#__PURE__*/React.createElement(BillingForm, {
        onSubmit: this.handleBillingFormSubmit,
        showTotal: false,
        checkoutInProgress: this.state.checkoutInProgress
      })), /*#__PURE__*/React.createElement("div", {
        className: styles.columnWrap
      }, contractInfo && /*#__PURE__*/React.createElement("div", {
        className: styles.col
      }, /*#__PURE__*/React.createElement("h3", {
        className: styles.header
      }, "Contact Details"), /*#__PURE__*/React.createElement("div", {
        className: styles.detailsWrap
      }, /*#__PURE__*/React.createElement("h6", {
        className: styles.detail
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.detailName
      }, "Business Name:"), ' ', contractInfo.contract.businessName), /*#__PURE__*/React.createElement("h6", {
        className: styles.detail
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.detailName
      }, "Owner Name:"), ' ', "".concat(contractInfo.contract.firstName, " ").concat(contractInfo.contract.lastName)), contractInfo.contract.email && contractInfo.contract.email !== '' && /*#__PURE__*/React.createElement("h6", {
        className: styles.detail
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.detailName
      }, "Email:"), ' ', contractInfo.contract.email), contractInfo.contract.phone && contractInfo.contract.phone !== '' && /*#__PURE__*/React.createElement("h6", {
        className: styles.detail
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.detailName
      }, "Phone:"), ' ', contractInfo.contract.phone))), contractInfo && /*#__PURE__*/React.createElement("div", {
        className: styles.col
      }, /*#__PURE__*/React.createElement("h3", {
        className: styles.header
      }, "Team Members"), /*#__PURE__*/React.createElement("div", {
        className: styles.detailsWrap
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h6", {
        className: styles.detail
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.detailName
      }, "Allowed:"), ' ', contractInfo.totals.teamMembersPermitted), /*#__PURE__*/React.createElement("h6", {
        className: styles.detail
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.detailName
      }, "In Use:"), ' ', contractInfo.totals.teamMembersUsed), /*#__PURE__*/React.createElement("h6", {
        className: styles.detail
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.detailName
      }, "Remaining:"), ' ', contractInfo.totals.teamMembersRemaining), /*#__PURE__*/React.createElement("h6", {
        className: styles.detail
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.detailName
      }, "Additional Team Members:"), ' ', "$", contractInfo.terms.additionalTeamMembersMonthlyPrice, "/mo")))), contractInfo && /*#__PURE__*/React.createElement("div", {
        className: styles.col
      }, /*#__PURE__*/React.createElement("h3", {
        className: styles.header
      }, "Clients"), /*#__PURE__*/React.createElement("div", {
        className: styles.detailsWrap
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h6", {
        className: styles.detail
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.detailName
      }, "Total In Use:"), ' ', contractInfo.totals.totalChildren), /*#__PURE__*/React.createElement("h6", {
        className: styles.detail
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.detailName
      }, "Added After Agreement:"), ' ', contractInfo.totals.endToEndChildren + contractInfo.totals.adsOnlyChildren), /*#__PURE__*/React.createElement("h6", {
        className: styles.detail
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.detailName
      }, "Allowed In Agreement:"), ' ', contractInfo.totals.clientsPermitted), /*#__PURE__*/React.createElement("h6", {
        className: styles.detail
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.detailName
      }, "Remaining From Agreement:"), ' ', contractInfo.totals.clientsRemaining)))), contractInfo && /*#__PURE__*/React.createElement("div", {
        className: styles.col
      }, /*#__PURE__*/React.createElement("h3", {
        className: styles.header
      }, "Agreement Details"), /*#__PURE__*/React.createElement("div", {
        className: styles.detailsWrap
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h6", {
        className: styles.detail
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.detailName
      }, "Start Date:"), ' ', contractInfo.totals.contractStartsAtFormatted), /*#__PURE__*/React.createElement("h6", {
        className: styles.detail
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.detailName
      }, "Terms:"), ' ', contractInfo.totals.contractLength), contractInfo.totals.contractRemainingNumMonths > 0 && contractInfo.terms.contractMonths !== 1 && /*#__PURE__*/React.createElement("h6", {
        className: styles.detail
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.detailName
      }, "Remaining Months:"), ' ', contractInfo.totals.contractRemainingNumMonths)))), partnerBillingDetails && partnerBillingDetails.paymentMethod && /*#__PURE__*/React.createElement("div", {
        className: styles.col
      }, /*#__PURE__*/React.createElement("h3", {
        className: styles.header
      }, "Payment Method", ' ', /*#__PURE__*/React.createElement("i", {
        style: {
          cursor: 'pointer'
        },
        className: "fa fa-pencil",
        onClick: function onClick() {
          return _this3.setState({
            editPaymentMethodModal: true
          });
        }
      })), /*#__PURE__*/React.createElement("div", {
        className: styles.detailsWrap
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h6", {
        className: styles.detail
      }, partnerBillingDetails.paymentMethod.name), /*#__PURE__*/React.createElement("h6", {
        className: styles.detail
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.detailName
      }, partnerBillingDetails.paymentMethod.brand), ' ', "\u2022\u2022\u2022\u2022 ", partnerBillingDetails.paymentMethod.last4), /*#__PURE__*/React.createElement("h6", {
        className: styles.detail
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.detailName
      }, "Exp:"), ' ', partnerBillingDetails.paymentMethod.exp_month, "/", partnerBillingDetails.paymentMethod.exp_year)))), contractInfo && /*#__PURE__*/React.createElement("div", {
        className: styles.col
      }, /*#__PURE__*/React.createElement("h3", {
        className: styles.header
      }, "Payment Details"), /*#__PURE__*/React.createElement("div", {
        className: styles.detailsWrap
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h6", {
        className: styles.detail
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.detailName
      }, "Total:"), " $", contractInfo.totals.totalBillCalculated, "/mo"))))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: styles.tabWrap
      }, /*#__PURE__*/React.createElement(QueueFlyoutTab, {
        isSelected: true,
        label: 'History',
        key: 0,
        style: {
          padding: '5px 16px'
        }
      })), /*#__PURE__*/React.createElement("div", {
        className: styles.bottomWrap
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12"
      }, this.props.subscriptionBillingHistory.length ? /*#__PURE__*/React.createElement(DataTable, {
        hideSort: true,
        headerFields: [{
          name: 'Date',
          key: 'createdDate'
        }, {
          name: 'Amount',
          key: 'amount'
        }, {
          name: 'Status',
          key: 'status'
        }],
        data: this.props.subscriptionBillingHistory,
        fixedHeader: true,
        height: 500,
        isLoading: this.props.loadingSubscriptionBillingHistory
      }) : /*#__PURE__*/React.createElement("p", {
        style: {
          color: this.props.theme.colors.gray2,
          marginBottom: 0
        }
      }, "No history yet."))))));
    }
  }]);

  return BillingManagement;
}(Component), _defineProperty(_class2, "propTypes", {
  getClientAgreementDetail: PropTypes.func
}), _temp)) || _class);
export { BillingManagement as default };